import defaultState from "./state";


const mantenedorSelReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOADING_MANTENEDOR_BATERIA": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "OPEN_CLOSE_MODAL_ELIMINAR_BATERIA": {
      return Object.assign({}, state, {
        isOpenModalEliminar: action.isOpen,
        batery: action.batery,
      });
    }
    case "SET_LISTA_BATERIAS_FILTRADAS": {
      return Object.assign({}, state, {
        listaBateriasFiltradas: action.lista,
      });
    }
    case "SET_BATERY": {
      return Object.assign({}, state, {
        batery: action.batery,
      });
    }
    case "OPEN_CLOSE_MODAL_EDITAR_BATERIA": {
      return Object.assign({}, state, {
        isOpenModalEditar: action.isOpen,
        batery: action.batery,
        isNewBatery: action.isNew,
      });
    }
    case "SET_LISTA_BATERIAS": {
      return Object.assign({}, state, {
        listaBaterias: action.data,
        listaBateriasFiltradas: action.data,
      });
    }
    case "SET_FILTROS_BATERIAS": {
      return Object.assign({}, state, {
        filtrosBaterias: action.filtros,
      });
    }
    case "OPEN_CLOSE_MODAL_DESACTIVAR_BATERIA": {
      return Object.assign({}, state, {
        isOpenModalDesactivar: action.isOpen,
        batery: action.batery,
      });
    }
    case "SET_EXAMS_LIST" : {
      return Object.assign({}, state, {
        listaPrestaciones: action.list
      })
    }

    default:
      return state;
  }
};
export default mantenedorSelReducer;
